module.exports = __webpack_public_path__ + "img/imagem_botafogo.bc539b90.png";